export default __webpack_public_path__ + "static/0185-fdd6a37d465fdf18bb4c090ad5daea66.png";